enum EmitOptions {
	FORM_CLOSED = 'formClosed',
	TOGGLE_ACCORDION = 'toggleAccordion',
	USER_CLICK = 'userClick',
	USER_CREATED = 'userCreated',
	VALUE_SELECTED = 'valueSelected'
}

export { EmitOptions };
